module.exports = __webpack_public_path__ + "16-o2.jpg?f6d32c9d1f666c190816084be9bbc95b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/16-o2.jpg
// module id = 631
// module chunks = 0